import local from '@/local/ar';
import Vue from '@/main';
import { setLookupInLocalStorage, setSubLookupInLocalStorage } from '../../helpers/utils';
import { requestOwnerTypeEnum } from '../../helpers/enum';
import api from '../../services/lookups-api';

const actionNames = local.bankruptcy.actions;

export default {
  getMainRequestCategories(store) {
    return getData(store, 'mainRequestCategories', 'getMainRequestCategories', actionNames.mainRequestCategories);
  },
  // Get Filtered Request Owner Types (exclude trustee)
  getRequestOwnerTypes(store) {
    return getData(store, 'requestOwnerTypes', 'getRequestOwnerTypes', actionNames.requestOwnerTypes, data => data.filter(item => item.id !== requestOwnerTypeEnum.trustee));
  },
  getAllRequestOwnerTypes(store) {
    return getData(store, 'allRequestOwnerTypes', 'getRequestOwnerTypes', actionNames.requestOwnerTypes);
  },
  getLegalCapacities(store) {
    return getData(store, 'legalCapacities', 'getLegalCapacities', actionNames.requestOwnerTypes);
  },
  getCommercialCourts(store) {
    return getData(store, 'commercialCourts', 'getCommercialCourts', actionNames.commercialCourts);
  },
  getProcedureTypes(store) {
    return getData(store, 'procedureTypes', 'getProcedureTypes', actionNames.procedureTypes);
  },
  getMainRequestStatuses(store) {
    return getData(store, 'mainRequestStatuses', 'getMainRequestStatuses', actionNames.mainRequestStatuses);
  },
  getIdentityTypes(store) {
    return getData(store, 'identityTypes', 'getIdentityTypes', actionNames.identityTypes);
  },
  getPartyTypes(store) {
    return getData(store, 'partyTypes', 'getPartyTypes', actionNames.partyTypes);
  },
  getFirmTypes(store) {
    return getData(store, 'firmTypes', 'getFirmTypes', actionNames.firmTypes);
  },
  getOrganizedEntityTypes(store) {
    return getData(store, 'organizedEntityTypes', 'getOrganizedEntityTypes', actionNames.organizedEntityTypes);
  },
  getDebtorClassifications(store) {
    return getData(store, 'debtorClassifications', 'getDebtorClassifications', actionNames.debtorClassifications);
  },
  getPartyTypeDebtorClassifications(store, payload) {
    return getDataByRelatedId(store, payload, 'partyTypeDebtorClassifications', 'getPartyTypeDebtorClassifications', actionNames.debtorClassifications);
  },
  getAssetTypes(store) {
    return getData(store, 'assetTypes', 'getAssetTypes', actionNames.assetTypes);
  },
  getRealEstateTypes(store) {
    return getData(store, 'realEstateTypes', 'getRealEstateTypes', actionNames.realEstateTypes);
  },
  getGlobalAttachmentTypes(store) {
    return getData(store, 'globalAttachmentTypes', 'getGlobalAttachmentTypes', actionNames.globalAttachmentType);
  },
  getCurrencies(store) {
    return getData(store, 'currencies', 'getCurrencies', actionNames.currencies);
  },
  getCountries(store) {
    return getData(store, 'countries', 'getCountries', actionNames.countries);
  },
  getRegionsByCountry(store, payload) {
    return getDataByRelatedId(store, payload, 'subRegions', 'getRegionsByCountry', actionNames.regions);
  },
  getCitiesByRegion(store, payload) {
    return getDataByRelatedId(store, payload, 'subCities', 'getCitiesByRegion', actionNames.cities);
  },
  getCountryCities(store, payload) {
    return getDataByRelatedId(store, payload, 'countryCities', 'getCountryCities', actionNames.countryCities);
  },
  getSubRequestTypes(store) {
    return getData(store, 'subRequestTypes', 'getSubRequestTypes', actionNames.subRequestTypes);
  },
  getSubRequestStatuses(store) {
    return getData(store, 'subRequestStatuses', 'getSubRequestStatuses', actionNames.subRequestStatuses);
  },
  getAttachmentTypes(store) {
    return getData(store, 'attachmentTypes', 'getAttachmentTypes', actionNames.globalAttachmentType);
  },
  getStakeholderTypes(store) {
    return getData(store, 'stakeholderTypes', 'getStakeholderTypes', actionNames.stakeholderTypes);
  },
};

const getData = ({ commit, state }, key, apiService, error, mapper = data => data) => {
  if (!state[key].length) {
    commit('update', {
      key,
      data: [],
    });
    return api[apiService]()
      .then((res) => {
        const data = mapper(res.data);
        commit('update', {
          key,
          data,
        });
        setLookupInLocalStorage(key, data);
        return data;
      })
      .catch(() => {
        Vue.toaster.error(local.errors.wentWrongWhile(error));
        return [];
      });
  } else {
    return Promise.resolve(state[key]);
  }
};

const getDataByRelatedId = (
  { commit, state },
  relatedId,
  key,
  apiService,
  error,
  mapper = data => data
) => {
  if (relatedId) {
    if (!state[key][relatedId] || !state[key][relatedId].length) {
      return api[apiService](relatedId)
        .then((res) => {
          const data = mapper(res.data);
          commit('updateSubLookup', {
            relatedId,
            key,
            data,
          });
          setSubLookupInLocalStorage(relatedId, key, data);
          return data;
        })
        .catch(() => {
          Vue.toaster.error(local.errors.wentWrongWhile(error));
          return [];
        });
    } else {
      return Promise.resolve(state[key][relatedId]);
    }
  } else {
    return Promise.resolve([]);
  }
};